import React from "react";

// Mirror of backend/milestones.py MILESTONES
const CATALOG = [
  { pearls: 100,    label: "First Wave",     emoji: "🥉" },
  { pearls: 500,    label: "Rising Star",    emoji: "🥈" },
  { pearls: 1000,   label: "1K Club",        emoji: "🥇" },
  { pearls: 5000,   label: "Crowd Favorite", emoji: "💎" },
  { pearls: 10000,  label: "10K Legend",     emoji: "👑" },
  { pearls: 50000,  label: "Icon",           emoji: "🏆" },
  { pearls: 100000, label: "Immortal",       emoji: "🌟" },
];

/** ProfileBadges — earned milestone badges shown on public profiles. */
export default function ProfileBadges({ milestones }) {
  const earned = new Set(milestones || []);
  const badges = CATALOG.filter((m) => earned.has(m.pearls));
  if (badges.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center justify-center gap-1.5 mt-2" data-testid="profile-badges">
      {badges.map((m) => (
        <span
          key={m.pearls}
          title={`${m.label} — ${m.pearls.toLocaleString()} pearls earned`}
          data-testid={`profile-badge-${m.pearls}`}
          className="inline-flex items-center gap-1 rounded-full crystal-glass border border-jam-gold/40 px-2.5 py-1"
        >
          <span className="text-sm leading-none">{m.emoji}</span>
          <span className="text-jam-gold text-[9px] tracking-[0.15em] uppercase font-black">{m.label}</span>
        </span>
      ))}
    </div>
  );
}
